import Vue from 'vue';
import FolderService from './folder.service';

const getDefaultItem = () => ({
    id: null,
    folderName: null,
    tenant: null,
});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
});

const user = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        clear(state) {
            Vue.set(state, 'item', JSON.parse(JSON.stringify(getDefaultState().item)));
            Vue.set(state, 'list', JSON.parse(JSON.stringify(getDefaultState().list)));
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        async queryRoot(context, client_data) {
            const { tenantId } = client_data;
            const { data } = await FolderService.queryRoot(tenantId);
            context.commit('updateList', data);
            return data;
        },
        async queryByParentFolder(context, client_data) {
            const { tenantId, parentFolderId } = client_data;
            const { data } = await FolderService.queryByParentFolder(tenantId, parentFolderId);
            context.commit('updateList', data);
            return data;
        },
        async createFolder(context, client_data) {
            const { tenantId, parentFolderId, folderName } = client_data;
            const { data } = await FolderService.create(tenantId, parentFolderId, folderName);
            context.commit('updateList', data);
            return data;
        },
    },

    getters: {
        list(state) {
            return state.list;
        },
    },
};

export default user;
